import { render } from "./EditOrDeletePoint.vue?vue&type=template&id=0fcb650b"
import script from "./EditOrDeletePoint.vue?vue&type=script&lang=js"
export * from "./EditOrDeletePoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__